import Script from 'next/script';
import { browserLogger } from '../../utils/loggers/browser';

type AwsWafScriptProps = {
  page: '/login' | '/signup' | '/product/signup';
};

/**
 * AWS WAF script to be included in the page for registration and login
 * Docs: https://docs.aws.amazon.com/waf/latest/developerguide/waf-js-challenge-api.html
 */
export const AwsWafScript = ({ page }: AwsWafScriptProps) => (
  <Script
    data-testid="aws-waf-script"
    src={`${process.env.NEXT_PUBLIC_AWS_WAF_URL}/challenge.compact.js`}
    onError={error => {
      browserLogger({
        level: 'warn',
        team: 'client-onboarding',
        message: 'AwsWafIntegration: script failed to load',
        context: {
          error: JSON.stringify(error),
          feature: 'aws-waf-integration',
          page,
        },
      });
    }}
    defer
  />
);
